import { type TUIResourceId } from '@/ducks/common/resources';

export const UI_RESOURCE_TITLES = [...Array(8)].reduce<Record<string, TUIResourceId>>(
  (acc, _, position) => ({
    ...acc,
    [`${position}`]: `QuickSearchPosition${position}.heading` as TUIResourceId,
  }),
  {},
);
